import { useBillingStore } from "@/store/billing";

export function BillingPage() {
  const currentBillingPageView = useBillingStore((s) => s.currentBillingPageView);
  const balanceDue = useBillingStore((s) => s.balanceDue);
  const setBillingCurrentPage = useBillingStore((s) => s.setBillingCurrentPage);

  if (currentBillingPageView === "MakePayment") {
    return (
      <div className="mx-auto max-w-2xl py-6">
        <button
          type="button"
          onClick={() => setBillingCurrentPage("BillingDefault")}
          className="inline-flex min-h-11 items-center text-primary underline hover:no-underline"
        >
          ← Back to Billing
        </button>
        <h2 className="mt-4 text-xl font-semibold">Make Payment</h2>
        <p className="mt-4 text-muted-foreground">
          Payment flow will be implemented here (Fortis integration).
        </p>
      </div>
    );
  }

  if (currentBillingPageView === "MakePaymentSuccess") {
    return (
      <div className="mx-auto max-w-2xl py-6">
        <h2 className="text-xl font-semibold">Payment successful</h2>
        <p className="mt-2 text-muted-foreground">
          Thank you for your payment.
        </p>
        <button
          type="button"
          onClick={() => setBillingCurrentPage("BillingDefault")}
          className="mt-4 min-h-11 rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground"
        >
          Back to Billing
        </button>
      </div>
    );
  }

  return (
    <div className="mx-auto max-w-2xl py-6">
      <h2 className="text-xl font-semibold">Billing</h2>
      <div className="mt-6 rounded-lg border border-border bg-card p-4">
        <p className="text-sm text-muted-foreground">Balance due</p>
        <p className="mt-1 text-2xl font-semibold">
          ${(balanceDue / 100).toFixed(2)}
        </p>
      </div>
      <button
        type="button"
        onClick={() => setBillingCurrentPage("MakePayment")}
        className="mt-4 min-h-11 rounded-md bg-primary px-4 py-2 text-sm font-medium text-primary-foreground hover:opacity-90"
      >
        Make Payment
      </button>
    </div>
  );
}
